import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { submitMfaExchange } from '@/services/login.service';
import type { MfaExchangeResponse } from '@/services/login.types';

export type MFAExchangeSubmitValues = {
  pinCode: string;
};

type MutationCallbacks = Pick<
  UseMutationOptions<MfaExchangeResponse, unknown, MFAExchangeSubmitValues>,
  'onSuccess' | 'onError'
>;

interface UseMFAExchangeMutationArgs extends MutationCallbacks {
  mfaCode: string;
}

const useMFAExchangeMutation = ({
  mfaCode,
  onSuccess,
  onError,
}: UseMFAExchangeMutationArgs) =>
  useMutation<MfaExchangeResponse, unknown, MFAExchangeSubmitValues>({
    mutationFn: ({ pinCode }) =>
      submitMfaExchange({ mfaCode, mfaChallenge: pinCode }),
    onSuccess,
    onError,
  });

export default useMFAExchangeMutation;
